<div
  *ngIf="results"
  class="student-results-wrap mat-elevation-z2 overflow-auto purple-medium-dark-theme-section purple-dark-border">
  <mat-checkbox
    *ngIf="showSelectedAllPeriod && results.length > 0"
    class="mb-2"
    labelPosition="before"
    [checked]="isAll"
    (change)="selectAll($event)">
    Выбрать все периоды данной группы
  </mat-checkbox>
  <ng-container *ngIf="results.length > 0; else empty">
    <div *ngFor="let period of results" class="mb-5 student-results-list-wrap">
      <div class="d-flex align-items-center mb-3">
        <p class="student-results-period-title mr-2">
          Период #{{ period.number }} -
          {{ period.start_date | date: 'dd.MM.y' }} -
          {{ period.finish_date | date: 'dd.MM.y' }}
        </p>

        <mat-checkbox
          *ngIf="showSelectedPeriod"
          color="primary"
          (change)="select($event, { id: period.id, number: period.number })"
          [checked]="isSelected(period.id)"></mat-checkbox>
      </div>

      <div class="student-results-list">
        <div class="student-results-header">
          <div class="d-flex student-results-homeworks">
            <div
              *ngFor="let homework of period.required_work_numbers"
              class="student-results-header-cell student-results-header-homeworks-wrap">
              <a
                target="_blank"
                class="student-results-header-homeworks"
                routerLink="/events/{{ homework.id }}"
                [matTooltip]="
                  !homework.work_required ? 'Работа необязательная' : ''
                "
                [ngClass]="
                  !homework.work_required && 'student-results-header-cell-green'
                ">
                #{{ homework.number }}
              </a>
            </div>
          </div>

          <div class="d-flex">
            <div
              class="student-results-header-cell student-results-average-points mx-2">
              Среднее за ДЗ
            </div>
            <div
              class="student-results-header-cell student-results-visits mx-2">
              Посещаемость
            </div>
            <div
              class="student-results-header-cell student-results-control-work mx-2">
              Контрольная работа
            </div>
            <div
              class="student-results-header-cell student-results-period-result mx-2">
              Итог
            </div>
          </div>
        </div>
        <div class="student-results-body d-flex">
          <div class="d-flex student-results-homeworks">
            <div
              *ngFor="let homework of period.students[0].homeworks"
              class="student-results-homework">
              <span
                *ngIf="
                  homework.status === studentsWorkStatus.NOT_UPLOADED
                "></span>
              <span
                *ngIf="
                  homework.status === studentsWorkStatus.UPLOADED ||
                  homework.status === studentsWorkStatus.IN_REVIEW
                ">
                0
              </span>
              <a
                *ngIf="homework.status === studentsWorkStatus.REVIEWED"
                [ngClass]="
                  homework.is_copied
                    ? 'student-results-work-copied'
                    : 'student-results-work-link'
                "
                class="student-results-homework-link"
                matTooltip="Перейти к рецензии"
                target="_blank"
                href="/student-works/reviews/{{ homework.review_id }}"
                >{{ homework.points }}</a
              >
            </div>
          </div>

          <div class="d-flex">
            <div
              class="student-results-cell student-results-average-points mx-2">
              {{ period.students[0].homework_points }}
            </div>
            <div class="student-results-cell student-results-visits mx-2">
              {{ period.students[0].visit_points }}
            </div>
            <div class="student-results-cell student-results-control-work mx-2">
              <span
                *ngIf="
                  period.students[0].exam.status ===
                  studentsWorkStatus.NOT_UPLOADED
                "></span>
              <span
                *ngIf="
                  period.students[0].exam.status ===
                    studentsWorkStatus.UPLOADED ||
                  period.students[0].exam.status ===
                    studentsWorkStatus.IN_REVIEW
                ">
                0
              </span>
              <a
                *ngIf="
                  period.students[0].exam.status === studentsWorkStatus.REVIEWED
                "
                [ngClass]="
                  period.students[0].exam.is_copied
                    ? 'student-results-work-copied'
                    : 'student-results-work-link'
                "
                target="_blank"
                matTooltip="Перейти к рецензии"
                href="/student-works/reviews/{{
                  period.students[0].exam.review_id
                }}"
                >{{ period.students[0].exam.points }}</a
              >
            </div>
            <div
              class="student-results-cell student-results-period-result mx-2">
              {{ period.students[0].period_result }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #empty>
    В данной группе студент не обучался ни в одном из периодов
  </ng-template>
</div>
